export enum MaintenanceStatus {
  ACTIVE = "ACTIVE",
  SCHEDULED = "SCHEDULED",
  CANCELLED = "CANCELLED",
  RELEASED = "RELEASED",
}

export enum ReminderType {
  CUSTOM = "CUSTOM",
  IMMEDIATE = "IMMEDIATE",
  NONE = "NONE",
}
